<template>
  <a-form-item
    v-if="data"
    :label="data.fieldname"
    class="select-tree"
  >
    <a-tree-select
      :value="value"
      :tree-data="treedata"
      :placeholder="placeholder"
      allow-clear
      show-search
      :multiple="multiple"
      :disabled="data.disabled"
      tree-default-expand-all
      @change="onChange"
    />
  </a-form-item>
</template>

<script>
// import SelectTree from './../formItem/SelectTree'
import _ from 'lodash'

export default {
  // extends: SelectTree,
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    placeholder: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
    getData: {
      type: Function,
      default: () => { }
    }
  },
  data () {
    return {
      value: [],

      treedata: [],
      treedataObj: {
        children: {}
      }
    }
  },
  computed: {
    fieldconfig () {
      const { fieldconfig = {} } = this.data
      return fieldconfig
    }
  },
  watch: {
    data: {
      handler (val) {
        this.init()
      },
      deep: true,
      immediate: true
    }
  },

  async created () {
    if (!this.data) return

    const { data = {} } = this
    let { options = [] } = data

    if (!options.length) {
      options = await this.loadData()
    }

    for (let item of options) {
      item.pId = '0'
      item.pName = ''
    }
    this.setOptions(options)

    this.setObjTreedata(this.treedataObj.children, this.treedata)
  },

  mounted () {
    this.$bus.$on('initSelectTreeFieldvalue', () => {
      this.init()
    })
  },
  beforeDestroy () {
    this.$bus.$off('initSelectTreeFieldvalue')
  },

  methods: {
    init () {
      if (!this.data) return

      // console.log('device', this.data)

      const { data = {} } = this
      let { fieldvalue = [] } = data
      this.data.fieldvalue = this.data.fieldvalue || {}
      if (this.$toType(fieldvalue) === 'array') {
        this.value = fieldvalue
      } else if (this.$toType(fieldvalue) === 'object') {
        this.value = Object.keys(fieldvalue)
      }

      // console.log('device', this.value)
    },
    async loadData () {
      const { fieldkey = '' } = this.data || {}

      const data = await this.getData({ fieldkey }) || {}

      return data
    },
    setOptions (options) {
      for (let item of options) {
        item.title = item.name
        // item.value = item.pId + '-' + item.id
        item.value = item.id
        item.key = item.pId + '-' + item.id

        if (item.children || item.child) {
          item.children = item.children || item.child || []
          for (let child of item.children) {
            child.pId = item.pId + '-' + item.id
            child.pName = item.pName + '/' + item.name
          }
          this.setOptions(item.children)
        }
      }
      this.treedata = options
    },
    onChange (value, label, extra) {
      // console.log(value, label, extra)
      this.value = value
      this.data.fieldvalue = _.zipObject(value, label)
      this.$emit('change', this.data.fieldvalue)
    },
    onSearch () {
      // console.log(...arguments)
    },
    onSelect () {
      // console.log(...arguments)
    },
    setObjTreedata (obj, options) {
      for (let item of options) {
        obj[item.id] = {}
        obj[item.id].name = item.name
        if (item.children) {
          obj[item.id].children = {}
          this.setObjTreedata(obj[item.id].children, item.children)
        }
      }
    }
  }
}
</script>

<style>
</style>
